import { toggleScroll } from "../utilities/toggleScroll";


document.addEventListener('DOMContentLoaded', function () {
  var promoBanner = document.querySelector('#promo-banner');
  if (promoBanner) {
    document.querySelector('header').classList.add('has-promo-banner');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('site-header');
  const mobileMenuOpen = document.getElementById('mobile-menu-open');

  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuClose = mobileMenu?.querySelector('.mobile-menu .icon__close');

  mobileMenuOpen?.addEventListener('click', () => {
    openMenu('mobile');
  });

  mobileMenuClose?.addEventListener('click', () => {
    closeMenus();
  });

  mobileMenu?.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      closeMenus();
    });
  });

  /**
   * @param {string} menu Then menus name
   *
   * @return void
   */
  function toggleMenu(menu) {
    if (header?.getAttribute('data-menu-active') === menu) {
      closeMenus();
    } else {
      openMenu(menu);
    }
  }

  /**
   * Opens the specified header menu
   *
   * @param {string} menu
   *
   * @return void
   */
  function openMenu(menu) {
    header?.setAttribute('data-menu-active', menu);
    toggleScroll(false);
  }

  /**
   * Closes all the header menus
   *
   * @return void
   */
  function closeMenus() {
    header?.removeAttribute('data-menu-active');
    toggleScroll(true);
  }



  // Mobile Menu Dropdowns
  const mobileDropdowns = document.querySelectorAll('.site-mobile-menu .menu-item-has-children .icon--arrow');

  mobileDropdowns.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggle.style.transform = toggle.style.transform === 'rotate(180deg)' ? 'rotate(0deg)' : 'rotate(180deg)';
      const menuItem = toggle.closest('.menu-item-has-children');
      if (menuItem) {
        if (menuItem.getAttribute('data-submenu-active') === 'true') {
          menuItem.removeAttribute('data-submenu-active');
        } else {
          menuItem.setAttribute('data-submenu-active', 'true');
        }
      }
    });
  });
});